import { useToast } from "vue-toastification";

const TIMEOUT = 3000;

const toast = useToast({
    // @ts-expect-error Fix later xD
    transition: "Vue-Toastification__fade",
    toastClassName: "app-toast",
    hideProgressBar: false,
});

export default {
    methods: {
        successToast(message, timeout = TIMEOUT) {
            toast.success(message, {
                timeout,
            });
        },
        warningToast(message: string, timeout: number = TIMEOUT) {
            toast.warning(message, {
                timeout,
            });
        },
        errorToast(message, timeout = TIMEOUT) {
            toast.error(message, {
                timeout,
            });
        },
    },
};
